import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-followers-list',
  templateUrl: './followers-list.component.html',
  styleUrls: ['./followers-list.component.css']
})
export class FollowersListComponent implements OnInit {
  users: any[] = [];
  loading = false;
  page = 1;
  pageSize = 24;
  canGoNext = false;

  constructor(
    public auth: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.fetch();
  }

  prevPage(): void {
    if (this.loading || this.page <= 1) { return; }
    this.page -= 1;
    this.fetch();
  }

  nextPage(): void {
    if (this.loading || !this.canGoNext) { return; }
    this.page += 1;
    this.fetch();
  }

  goToPage(p: number): void {
    if (this.loading || p < 1) { return; }
    this.page = p;
    this.fetch();
  }

  message(user: any): void {
    // Navigate to messaging with the user
    this.router.navigate(['/messages'], { queryParams: { userId: user._id } });
  }

  private fetch(append = false): void {
    this.loading = true;
    const skip = String((this.page - 1) * this.pageSize);
    const limit = String(this.pageSize);
    this.auth.getFollowers({ skip, limit }).subscribe((res: any) => {
      const data = res?.items || res?.data || [];
      this.users = append ? [...this.users, ...data] : data;
      this.canGoNext = Array.isArray(data) && data.length === this.pageSize;
      if (!this.users.length && this.page > 1) {
        this.page -= 1;
        this.canGoNext = false;
      }
      this.loading = false;
    }, _ => this.loading = false);
  }
}

